import { Box, Flex } from 'pcln-design-system'
import React from 'react'
import styled from 'styled-components'
import { PROPVALUE } from '../constants'
import Value from './Value'

const Wrapper = styled(Box)`
  max-width: 1280px;
`

const PropValue = (props) => {
  const data = props.content || PROPVALUE

  return (
    <Wrapper
      color='background.light'
      m='auto'
      pt={4}
      px={[4, null, null, null, 5]}
      pb={[5, null, null, null, 4, 5]}
    >
      <Flex flexWrap='wrap' flexDirection={['column', 'row', 'row']}>
        {data.map(({ id, ...props }) => {
          return <Value key={id} {...props} />
        })}
      </Flex>
    </Wrapper>
  )
}

export { PropValue }
export default PropValue
